import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
  selector: "app-radioButtonCustom",
  template: `
<div class="wrapper">
    <input type="radio" name="select" [id]="field.name" [checked]="field.checked" (click)="field.onClick()">
    <label [for]="field.name" [class]="field.class">
        <span>{{field.label}}</span>
    </label>
</div>
`,
  styles: []
})
export class RadiobuttonCustomComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
